module.exports = __webpack_public_path__ + "img/znacka.8efd0702.jpg";